function TopBanner() {
  return (
    <div className="top-banner w-full">
      <h1 className="text-gray-600 text-3xl bold w-full h-20 bg-gradient-to-r from-white to-gray-200 text-center align-middle items-center p-5 text-serif">Rachael's Nannying</h1>
    </div>
  );
}

export default TopBanner;